'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$IP$$anon$77(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$IP$$anon$77 as $c_Lpresto_types$IP$$anon$77 };
$p = $c_Lpresto_types$IP$$anon$77.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$IP$$anon$77;
/** @constructor */
function $h_Lpresto_types$IP$$anon$77() {
}
export { $h_Lpresto_types$IP$$anon$77 as $h_Lpresto_types$IP$$anon$77 };
$h_Lpresto_types$IP$$anon$77.prototype = $p;
$p.bO = (function(text) {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(text);
});
$p.bK = (function(t) {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(t);
});
var $d_Lpresto_types$IP$$anon$77 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$IP$$anon$77, "presto.types$IP$$anon$77", ({
  a0E: 1,
  K: 1
}));
export { $d_Lpresto_types$IP$$anon$77 as $d_Lpresto_types$IP$$anon$77 };
//# sourceMappingURL=presto.types$-I-P$$anon$77.js.map
